export const stripWhitespace = str => str.replace(/\s+/g, '');
